module.exports = __webpack_public_path__ + "img/home-act.ce92800e.png";